(() => {
  const initialize = () => {
    const existing = Alpine.store('xQuickView');
    if (existing && typeof existing.loadChooseOptions === 'function' && typeof existing.load === 'function') return;
    const pending = new Map();
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'en').split('-')[0];
    const copy = {
      it: ['Impossibile caricare il prodotto. Controlla la connessione e riprova.', 'Riprova'],
      en: ['Unable to load the product. Check your connection and try again.', 'Try again'],
      de: ['Das Produkt konnte nicht geladen werden. Bitte prüfen Sie Ihre Verbindung.', 'Erneut versuchen'],
      fr: ['Impossible de charger le produit. Vérifiez votre connexion et réessayez.', 'Réessayer'],
      es: ['No se pudo cargar el producto. Revisa tu conexión e inténtalo de nuevo.', 'Reintentar'],
      pt: ['Não foi possível carregar o produto. Verifique a ligação e tente novamente.', 'Tentar novamente'],
      nl: ['Het product kon niet worden geladen. Controleer je verbinding en probeer opnieuw.', 'Opnieuw proberen'],
      pl: ['Nie można załadować produktu. Sprawdź połączenie i spróbuj ponownie.', 'Spróbuj ponownie']
    }[locale] || ['Unable to load the product. Check your connection and try again.', 'Try again'];
    // Share in-flight requests and release failures, including a hung connection.
    const fetchMarkup = (url) => {
      if (pending.has(url)) return pending.get(url);
      const controller = new AbortController();
      let timer;
      const timeout = new Promise((_, reject) => {
        timer = setTimeout(() => {
          controller.abort();
          reject(new Error('Product request timed out'));
        }, 15000);
      });
      const request = Promise.race([
        fetch(url, { signal: controller.signal }).then(response => {
          if (!response.ok) throw new Error('Product request failed: ' + response.status);
          return response.text();
        }), timeout
      ]).finally(() => {
        clearTimeout(timer);
        pending.delete(url);
      });
      pending.set(url, request);
      return request;
    };
    const showError = (destination, retry) => {
      if (!destination) return;
      const message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.className = 'p-5';
      message.textContent = copy[0];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button-solid m-5 px-5 py-3';
      button.textContent = copy[1];
      button.addEventListener('click', retry);
      destination.replaceChildren(message, button);
    };
    const configureButtons = (destination) => {
      const add = destination?.querySelector('.add_to_cart_button');
      const quick = destination?.querySelector('.label-btn-quickview');
      if (add) add.style.display = 'block';
      if (quick) quick.style.display = 'none';
    };
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView?.sectionId,
      enabled: window.xQuickView?.enabled ?? false,
      buttonLabel: window.xQuickView?.buttonLabel || '',
      show_atc_button: window.xQuickView?.show_atc_button ?? true,
      btn_atc_bottom: window.xQuickView?.atc_btn_bottom ?? false,
      atc_btn_image_desktop: window.xQuickView?.atc_btn_image_desktop ?? true,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: {},
      cachedfetch: {},
      loadingUrls: [],
      loadedChooseOptions: {},
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      openPopupMobile: false,
      isMiniCart: false,
      buttonQuickView: '',
      _viewRequest: 0,
      _chooseRequest: 0,
      _renderedMobileUrl: '',
      _renderedDesktop: {},
      _chooseArguments: {},
      _listening: false,
      init() { this.addListener(); },
      addListener() {
        if (this._listening) return;
        this._listening = true;
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = {};
          this.loadedChooseOptions = {};
          this._renderedMobileUrl = '';
          this._renderedDesktop = {};
        });
      },
      showBtn(enable, showATCButton, showQTYSelector, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn ?? showQTYSelector;
        this.show_atc_button = showATCButton;
      },
      async load(url, el, optionId) {
        const sequence = ++this._viewRequest;
        this.loading = true;
        this.buttonQuickView = el;
        const variant = document.getElementById('current-variant-' + optionId)?.innerText?.trim();
        const productUrl = `${url}${url.includes('?') ? '&' : '?'}${variant ? 'variant=' + encodeURIComponent(variant) + '&' : ''}section_id=${encodeURIComponent(this.sectionId)}`;
        const destination = document.getElementById('quickview-product-content');
        try {
          let content = this.cachedResults[productUrl];
          if (!content) {
            this.cachedfetch[productUrl] = true;
            const response = await fetchMarkup(productUrl);
            content = new DOMParser().parseFromString(response, 'text/html').getElementById('quickview-product-content')?.innerHTML;
            if (!content) throw new Error('Product content is missing');
            this.cachedResults[productUrl] = content;
          }
          if (sequence === this._viewRequest && destination) destination.innerHTML = content;
          return true;
        } catch (error) {
          if (sequence === this._viewRequest) showError(destination, () => this.load(url, el, optionId));
          return false;
        } finally {
          this.cachedfetch[productUrl] = false;
          if (sequence === this._viewRequest) this.loading = false;
        }
      },
      async loadChooseOptions(url, el, optionId, index) {
        const sequence = ++this._chooseRequest;
        const urlProduct = `${url}${url.includes('?') ? '&' : '?'}section_id=choose-option&page=${encodeURIComponent(index)}`;
        const card = document.getElementById('choose-options-' + optionId);
        const desktop = card?.querySelector('.choose-options');
        const mobile = document.getElementById('choose-options-mobile');
        const spinner = card?.querySelector('.icon-loading');
        const destination = () => window.innerWidth > 767 ? desktop : mobile;
        this._chooseArguments[optionId] = [url, el, optionId, index];
        this.loadingChooseOption = true;
        spinner?.classList.remove('hidden');
        if (!this.loadingUrls.includes(urlProduct)) this.loadingUrls.push(urlProduct);
        try {
          let content = this.loadedChooseOptions[urlProduct];
          if (!content) {
            const response = await fetchMarkup(urlProduct);
            content = new DOMParser().parseFromString(response, 'text/html').getElementById('choose-options-content')?.innerHTML;
            if (!content) throw new Error('Product options are missing');
            this.loadedChooseOptions[urlProduct] = content;
          }
          if (sequence !== this._chooseRequest) return false;
          const target = destination();
          if (window.innerWidth > 767) {
            if (target && (this._renderedDesktop[optionId] !== urlProduct || !target.querySelector('.choose-options-content'))) target.innerHTML = content;
            this._renderedDesktop[optionId] = urlProduct;
            if (mobile) mobile.innerHTML = '';
            this._renderedMobileUrl = '';
          } else {
            if (target && (this._renderedMobileUrl !== urlProduct || !target.querySelector('.choose-options-content'))) target.innerHTML = content;
            this._renderedMobileUrl = urlProduct;
            if (desktop) desktop.innerHTML = '';
            delete this._renderedDesktop[optionId];
          }
          configureButtons(target);
          return true;
        } catch (error) {
          if (sequence === this._chooseRequest) {
            this._renderedMobileUrl = '';
            delete this._renderedDesktop[optionId];
            showError(destination(), () => this.loadChooseOptions(url, el, optionId, index));
          }
          return false;
        } finally {
          spinner?.classList.add('hidden');
          const position = this.loadingUrls.indexOf(urlProduct);
          if (position !== -1) this.loadingUrls.splice(position, 1);
          if (sequence === this._chooseRequest) this.loadingChooseOption = false;
        }
      },
      open(isMiniCart = false) {
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        this.buttonQuickView = '';
        if (!Alpine.store('xMiniCart').open) Alpine.store('xPopup').close();
      },
      focusQuickView(quickView, btnClose) {
        if (!this.selected) Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
      },
      removeFocusQuickView() {
        if (!this.selected) Alpine.store('xFocusElement').removeTrapFocus(document.getElementById('button_quickview'));
      },
      closePopupMobile() { this.openPopupMobile = false; },
      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest('.card-product');
        let args = this._chooseArguments[id];
        // Keyboard/touch activation must not depend on a preceding mouseover.
        if (!args) {
          const href = product?.querySelector('a[href*="/products/"]')?.getAttribute('href');
          const index = id.match(/-(\d+)$/)?.[1] || '1';
          if (href) args = [href.split('?')[0], el, id, index];
        }
        if (args) this.loadChooseOptions(...args);
        configureButtons(window.innerWidth > 767 ? product?.querySelector('.choose-options') : document.getElementById('choose-options-mobile'));
      },
      clickInsideQuickView(evt) {
        if (this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) { evt.stopPropagation(); }
    });
  };
  if (window.Alpine) initialize();
  else document.addEventListener('alpine:init', initialize, { once: true });
})();
